import { atom } from "recoil";

const authAtom = atom({
  key: "authAtom",
  default: localStorage.getItem("boomviber-i-auth")
    ? JSON.parse(localStorage.getItem("boomviber-i-auth"))
    : null,
});

export default authAtom;
